module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称",
      "size": "small"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品编号",
      "size": "small"
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "small",
      "placeholder": "商品产地",
      "options": _vm.regions,
      "clearable": ""
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.select_regions_value),
      callback: function($$v) {
        _vm.select_regions_value = $$v
      },
      expression: "select_regions_value"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.goodsSearch
    },
    model: {
      value: (_vm.params.approve_status),
      callback: function($$v) {
        _vm.$set(_vm.params, "approve_status", $$v)
      },
      expression: "params.approve_status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "商品类型"
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.params.special_type),
      callback: function($$v) {
        _vm.$set(_vm.params, "special_type", $$v)
      },
      expression: "params.special_type"
    }
  }, _vm._l((_vm.special_type_list), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "商品类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('shop-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "distributors": "",
      "shopIdDefault": _vm.params.distributor_id
    },
    on: {
      "update": _vm.goodsSearch
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.batchItemsAudit()
      }
    }
  }, [_vm._v("批量审核")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.batchItemsStatus('onsale')
      }
    }
  }, [_vm._v("批量上架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.batchItemsStatus('instock')
      }
    }
  }, [_vm._v("强制下架")])], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.ItemsList,
        "height": _vm.wheight - 330
      },
      on: {
        "selection-change": _vm.handleSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "align": "center",
        "label": "全选"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "100",
        "fixed": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editItemsAction(scope.$index, scope.row)
              }
            }
          }, [(scope.row.audit_status == 'processing') ? _c('span', [_vm._v("审核")]) : _c('span', [_vm._v("查看")])])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goods_id",
        "label": "商品ID",
        "width": "90"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "排序编号",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "mini"
            },
            on: {
              "change": function($event) {
                return _vm.editItemsSort(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.sort),
              callback: function($$v) {
                _vm.$set(scope.row, "sort", $$v)
              },
              expression: "scope.row.sort"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "规格",
        "width": "70"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(!scope.row.nospec) ? _c('el-tag', {
            attrs: {
              "effect": "plain",
              "type": "success"
            }
          }, [_vm._v("多规格")]) : _c('el-tag', {
            attrs: {
              "effect": "plain"
            }
          }, [_vm._v("单规格")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "itemName",
        "label": "商品名称"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(scope.row.item_name) + "\n              "), (scope.row.special_type == 'drug') ? _c('el-tag', {
            attrs: {
              "type": "danger",
              "size": "mini"
            }
          }, [_vm._v("处方药")]) : _vm._e()]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "store",
        "label": "库存",
        "width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "状态",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.audit_status == 'processing') ? _c('span', [_vm._v("等待审核")]) : (scope.row.audit_status == 'rejected') ? _c('el-popover', {
            attrs: {
              "placement": "top-start",
              "width": "200",
              "trigger": "hover",
              "content": scope.row.audit_reason
            }
          }, [_c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_vm._v("审核驳回")])], 1) : (scope.row.approve_status == 'onsale') ? _c('span', [_vm._v("前台可销")]) : (scope.row.approve_status == 'offline_sale') ? _c('span', [_vm._v("可线下销售")]) : (scope.row.approve_status == 'only_show') ? _c('span', [_vm._v("前台仅展示")]) : _c('span', [_vm._v("不可销售")])]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量审核店铺商品",
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.audit_status),
      callback: function($$v) {
        _vm.$set(_vm.form, "audit_status", $$v)
      },
      expression: "form.audit_status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "approved"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "rejected"
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), (_vm.form.audit_status == 'rejected') ? _c('el-form-item', {
    attrs: {
      "label": "拒绝原因"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.audit_reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "audit_reason", $$v)
      },
      expression: "form.audit_reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a870cba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a870cba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/audit/list.vue
// module id = 2564
// module chunks = 0